/**
 * LoadingSpinner — minimal amber-arc spinner on a rule-toned ring. Uses
 * design tokens; no slate/gray/blue defaults.
 */

interface LoadingSpinnerProps {
  /** Text to display below the spinner */
  text?: string
  /** Alias for text */
  label?: string
  size?: 'sm' | 'md' | 'lg'
}

const sizeClasses: Record<string, string> = {
  sm: 'h-5 w-5 border-2',
  md: 'h-8 w-8 border-2',
  lg: 'h-12 w-12 border-[3px]',
}

const textSizeClasses: Record<string, string> = {
  sm: 'text-[10px]',
  md: 'text-[11px]',
  lg: 'text-[12px]',
}

export function LoadingSpinner({ text, label, size = 'md' }: LoadingSpinnerProps) {
  const displayText = text ?? label
  return (
    <div
      className="flex flex-col items-center justify-center gap-3"
      role="status"
      aria-busy="true"
      data-testid="loading-spinner"
    >
      <div
        className={`animate-spin rounded-full border-rule border-t-amber ${sizeClasses[size]}`}
        data-testid="spinner-element"
      />
      {displayText && (
        <p
          className={`font-mono uppercase tracking-[0.12em] text-muted ${textSizeClasses[size]}`}
          data-testid="loading-text"
        >
          {displayText}
        </p>
      )}
    </div>
  )
}
